import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M19.1693 9.34251L8.96386 2.53677C8.48266 2.21572 7.92327 2.03146 7.34547 2.00368C6.76767 1.97591 6.19318 2.10565 5.68341 2.37906C5.17364 2.65247 4.74774 3.05927 4.45123 3.55596C4.15473 4.05266 3.99876 4.62059 4.00001 5.19905V18.8073C3.99992 19.3853 4.15673 19.9524 4.4537 20.4481C4.75067 20.9439 5.17666 21.3498 5.68623 21.6224C6.1958 21.8951 6.76982 22.0243 7.34706 21.9962C7.92431 21.9682 8.48311 21.784 8.96386 21.4632L19.1693 14.6575C19.6065 14.366 19.9649 13.971 20.2129 13.5077C20.4608 13.0444 20.5905 12.5271 20.5905 12.0016C20.5905 11.4761 20.4608 10.9588 20.2129 10.4955C19.9649 10.0322 19.6065 9.63403 19.1693 9.34251Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

PlayIcon.displayName = 'PlayIcon';
